module.exports = __webpack_public_path__ + "img/left-arrow.5e4e3755.svg";